import { render, staticRenderFns } from "./LiveStreamVideo.vue?vue&type=template&id=5870b50b"
import script from "./LiveStreamVideo.vue?vue&type=script&lang=js"
export * from "./LiveStreamVideo.vue?vue&type=script&lang=js"
import style0 from "./LiveStreamVideo.vue?vue&type=style&index=0&id=5870b50b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports